import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CLabel } from '@coreui/react';
import Select from 'react-select';
import './styles.scss';

const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 99,
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  control: (provided) => ({
    ...provided,
    minHeight: 35,
  }),
  valueContainer: (provided) => ({
    ...provided,
  }),
  indicatorContainer: (provided) => ({
    ...provided,
    padding: '6px',
  }),
};

const CustomMultiSelect = ({
  options,
  className,
  title,
  id,
  darkMode,
  placeholder,
  labelKey,
  valueKey,
  ...selectProps
}) => {
  const optionsList = useMemo(
    () => options.map((i) => ({ value: i[valueKey], label: i[labelKey] })),
    [options, labelKey, valueKey],
  );
  return (
    <div className={className}>
      {title && <CLabel htmlFor={id}>{title}</CLabel>}
      <Select
        {...selectProps}
        id={id}
        isMulti
        theme={(theme) => ({
          ...theme,
          heigth: 35,
          colors: {
            ...theme.colors,
            primary: darkMode ? 'black' : theme.colors.primary,
            primary25: darkMode ? 'black' : theme.colors.primary25,
            primary50: darkMode ? 'black' : theme.colors.primary50,
            primary75: darkMode ? 'black' : theme.colors.primary75,
            dangerLight: darkMode ? 'black' : theme.colors.dangerLight,
            neutral0: darkMode ? '#2a2b36' : theme.colors.neutral0,
            neutral5: darkMode ? 'white' : theme.colors.neutral5,
            neutral10: darkMode ? 'white' : theme.colors.neutral10,
            neutral20: darkMode ? 'white' : theme.colors.neutral20,
            neutral30: darkMode ? 'white' : theme.colors.neutral30,
            neutral40: darkMode ? 'white' : theme.colors.neutral40,
            neutral50: darkMode ? 'white' : theme.colors.neutral50,
            neutral60: darkMode ? 'white' : theme.colors.neutral60,
            neutral70: darkMode ? 'white' : theme.colors.neutral70,
            neutral80: darkMode ? 'white' : theme.colors.neutral80,
            neutral90: darkMode ? 'white' : theme.colors.neutral90,
          },
        })}
        placeholder={placeholder}
        options={optionsList}
        styles={customStyles}
        className={classnames(['mxw-100-xs multiselect'])}
      />
    </div>
  );
};
CustomMultiSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape),
  className: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  darkMode: PropTypes.bool,
  placeholder: PropTypes.string,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
};

CustomMultiSelect.defaultProps = {
  placeholder: 'Select...',
  options: [],
  className: '',
  title: '',
  darkMode: false,
  id: null,
  labelKey: 'label',
  valueKey: 'value',
};

export default React.memo(CustomMultiSelect);
